// frontend/src/utils/dateUtils.js

export const formatDate = (dateString) => {
  if (!dateString) return 'Data não informada';
  const datePart = String(dateString).split('T')[0];
  const [year, month, day] = datePart.split('-');
  if (!year || !month || !day) return 'Data inválida';
  return `${day}/${month}/${year}`;
};

export const formatDateISO = (dateString) => {
  if (!dateString) return null;
  return String(dateString).split('T')[0];
};

export const isSameDay = (dateA, dateB) => {
  if (!dateA || !dateB) return false;
  const a = dateA instanceof Date
    ? `${dateA.getFullYear()}-${String(dateA.getMonth() + 1).padStart(2, '0')}-${String(dateA.getDate()).padStart(2, '0')}`
    : String(dateA).split('T')[0];
  const b = dateB instanceof Date
    ? `${dateB.getFullYear()}-${String(dateB.getMonth() + 1).padStart(2, '0')}-${String(dateB.getDate()).padStart(2, '0')}`
    : String(dateB).split('T')[0];
  return a === b;
};

export const formatPhone = (phone) => {
  if (!phone) return 'Não informado';
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return phone;
};